
import { Severity, useSnackbar } from 'hooks/notification'
import React from 'react'
import { createContext, ReactNode } from 'react'

interface SnackbarContextType {
  showMessage: (message: string, severity: Severity, timeout?: number) => void
}

const SnackbarContext = createContext<SnackbarContextType | undefined>(undefined)

export const SnackbarProvider = ({ children }: { children: ReactNode }) => {
  const { showMessage, SnackbarComponent } = useSnackbar()

  return (
    <SnackbarContext.Provider value={{ showMessage }}>
      {children}
      <SnackbarComponent />
    </SnackbarContext.Provider>
  )
}

export const useSnackbarContext = (): SnackbarContextType => {
  const context = React.useContext(SnackbarContext)
  if (!context) throw new Error('useSnackbarContext must be used within SnackbarProvider')
  return context
}
